document.addEventListener('DOMContentLoaded', () => {

    const productGrid = document.querySelector('#product-grid');
    const productGridContainer = document.querySelector('#ProductGridContainer');

    if (!productGrid || !productGridContainer) return;

    const pagination = document.querySelector('.pagination');
    if (!pagination) return;

    const seenUrls = new Set([window.location.href]);

    function getNextUrl(paginationEl) {
        if (!paginationEl) return null;
        const nextLink = paginationEl.querySelector('a.pagination__item--prev');
        const href = nextLink ? nextLink.getAttribute('href') : null;
        if (!href || href.trim() === '') return null;
        return new URL(href, window.location.origin).toString();
    }

    let nextUrl = getNextUrl(pagination);
    let isLoading = false;
    let isEnd = !nextUrl;

    const OFFSET = 600; // сколько px до низа начинаем грузить

    // Необязательный индикатор загрузки
    const loader = document.createElement('div');
    loader.className = 'collection-infinite-loader';
    loader.textContent = 'Loading...';
    loader.style.textAlign = 'center';
    loader.style.padding = '20px 0';
    loader.style.display = 'none';
    productGrid.after(loader);

    function showLoader(show) {
        loader.style.display = show ? 'block' : 'none';
    }

    async function loadNextPage() {
        if (!nextUrl || isLoading || isEnd) return;

        isLoading = true;
        showLoader(true);

        const currentUrl = nextUrl;
        try {
            const response = await fetch(currentUrl, {
                headers: { 'X-Requested-With': 'XMLHttpRequest' },
            });
            if (!response.ok) throw new Error('Network error');

            const html = await response.text();

            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');

            // Вытаскиваем товары из следующей страницы
            const newGrid = doc.querySelector('#ProductGridContainer');
            const newItems = newGrid ? newGrid.querySelectorAll('.grid__item, [data-product-id]') : [];

            newItems.forEach((item) => {
                productGrid.appendChild(item);
            });

            seenUrls.add(currentUrl);

            // Обновляем пагинацию и nextUrl из новой страницы
            const newPagination = doc.querySelector('.pagination');
            const resolvedNextUrl = getNextUrl(newPagination);
            if (resolvedNextUrl && !seenUrls.has(resolvedNextUrl)) {
                nextUrl = resolvedNextUrl;
                isEnd = false;
            } else {
                nextUrl = null;
                isEnd = true;
            }

            pagination.remove();
        } catch (e) {
            console.error('Infinite scroll error:', e);
            isEnd = true;
        } finally {
            isLoading = false;
            showLoader(false);
        }
    }

    function onScroll() {
        if (isEnd || isLoading || !nextUrl) return;

        const scrollPosition = window.innerHeight + window.scrollY;
        const containerRect = productGridContainer.getBoundingClientRect();
        const bottomPosition = containerRect.bottom + window.scrollY - OFFSET;

        if (scrollPosition >= bottomPosition) {
            loadNextPage();
        }
    }

    window.addEventListener('scroll', onScroll, { passive: true });
});